import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

interface GlobalLoaderContextValue {
  isLoading: boolean;
}

const GlobalLoaderContext = createContext<GlobalLoaderContextValue>({ isLoading: false });

// Module-level escape hatch — lets non-React code (Axios interceptors) trigger loading state.
// Initialized as no-ops so calls before React mounts are harmless.
export let incrementLoader: () => void = () => {};
export let decrementLoader: () => void = () => {};

export function GlobalLoaderProvider({ children }: { children: ReactNode }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    incrementLoader = () => setCount((c) => c + 1);
    decrementLoader = () => setCount((c) => Math.max(0, c - 1));
  }, []);

  return (
    <GlobalLoaderContext.Provider value={{ isLoading: count > 0 }}>
      {children}
    </GlobalLoaderContext.Provider>
  );
}

export function useGlobalLoader() {
  return useContext(GlobalLoaderContext);
}
